import { Category, ListParentCategory } from '@ortros/stoux-lib'

import { CategoryRepository } from '../repositories/category'
import { ListCategoriesInput } from '../schemas'

type InjectedDependencies = {
    categoryRepository: CategoryRepository
}

type ListCategoryResponse = {
    categories: Category[]
    count: number
    limit: number
    offset: number
}

export class CategoryService {
    private readonly _categoryRepository: CategoryRepository

    constructor({ categoryRepository }: InjectedDependencies) {
        this._categoryRepository = categoryRepository
    }

    public async getFeaturedCategories(): Promise<ListCategoryResponse> {
        return this._categoryRepository.getFeaturedCategories()
    }

    public async listCategories(options: ListCategoriesInput) {
        return this._categoryRepository.listCategories(options)
    }

    public async getParentCategoriesWithDepth(): Promise<Category[]> {
        return this._categoryRepository.getParentCategoriesWithDepth()
    }
}
